import { Section } from "../../../patterns/Section.js";
import type { PageLayoutProps } from "../../contract.js";
import type { InventoryContent } from "../inventoryContent.js";

/**
 * The inventory, showroom layout: the account's header and tabs, the vault,
 * and the selection bar floating at the bottom of the view while units are picked.
 */
export function InventoryShowroomLayout({ sections }: PageLayoutProps<InventoryContent>) {
  return (
    <Section className="flex flex-col gap-6 pt-6 pb-20 md:gap-8">
      {sections.header}
      {sections.tabs}
      {sections.vault}
      {sections.selection}
    </Section>
  );
}
